import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitPrescriptionPage } from './init-prescription';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    InitPrescriptionPage,
  ],
  imports: [
    IonicPageModule.forChild(InitPrescriptionPage),
    PipesModule,
  ],
})
export class InitPrescriptionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-prescription/init-prescription.module.ts